import type React from 'react';
import { Navigate } from 'react-router-dom';
import { getUser } from '../utils';
import { getRoleHomePath } from './roleHome';

/**
 * Sends `/` to the signed-in user's role home (`Seller` → POS, `BranchAdmin` →
 * management). Rendered inside `SecuredRoutes`, so a user always exists.
 */
export const RoleHomeRedirect: React.FC = () => (
    <Navigate replace to={getRoleHomePath(getUser()?.role)} />
);
